<template>
  <div class="content-main">

    <div class="ptitle">⬇️微信扫码添加课代表</div>
    <img class="qrcode" src="https://static.huiyiji520.com/qrcode-1766994602.jpg">

  </div>
</template>

<script>
// import wx from 'weixin-js-sdk'
// import { Toast, Dialog, Popup } from 'vant'

export default{
  data(){
    return {

    }
  },
  methods: {

  },
  mounted(){
    // this.wxConfigInit()
  }
}
</script>

<style scoped>
.content-main{ min-height:100vh;background-color: #f8f8f8;color:#333;padding-top:30%;}

.ptitle{font-size:34px;font-weight:bold;margin-bottom:8px;color:#000;}
.qrcode{
  width:340px;display:block;margin:0 auto;margin-top:20px;margin-bottom:20px;
  box-shadow:0px 2px 6px rgba(0,0,0,0.15);
}
.account{font-weight:bold;color:#b17e94;}
.hints{font-size:30px;}
.hints .hint{margin-bottom:16px;}
</style>
